import React from 'react';
import { CheckIcon } from 'lucide-react';
interface CheckItemProps {
  children: React.ReactNode;
  className?: string;
  inline?: boolean;
}
export function CheckItem({
  children,
  className = '',
  inline = false
}: CheckItemProps) {
  return <li className={`flex ${inline ? 'inline-flex' : ''} items-start gap-2.5 ${className}`} data-id="element-328" data-mp="10q62070rj4f4">
      <span className="mt-0.5 flex h-[18px] w-[18px] flex-shrink-0 items-center justify-center rounded-full bg-mp-lime/15" data-id="element-329" data-mp="vsmr9h39x9rx">
        <CheckIcon className="h-3 w-3 text-mp-lime" strokeWidth={3} data-id="element-330" data-mp="843gmuwr4kwo" />
      </span>
      <span className="text-sm text-mp-gray md:text-[15px]" data-id="element-331" data-mp="42i111su1sis">{children}</span>
    </li>;
}